import type { FC } from 'react';
import type { ModerationDetail, ModerationKind } from '../types';
import type { ModerationActions } from '../hooks/useModerationActions';
import { ReportSummaryCard } from './ReportSummaryCard';
import { FeedbackSummaryCard } from './FeedbackSummaryCard';
import { UserVariantCard } from './UserVariantCard';
import { ReportedContentCard } from './ReportedContentCard';
import { ReportedCommentCard } from './ReportedCommentCard';
import { ReportedMessageCard } from './ReportedMessageCard';

/**
 * Variant-card registry (doc 09 §4.5). One typed entry per kind drives the per-variant UI — no scattered
 * switches in JSX. Adding a 6th kind later is one entry here. Because ModerationDetail is a discriminated
 * union, each card narrows on report.kind and gets typed access to its group with no casts.
 */
export interface VariantConfig {
  SummaryCard: FC<{ report: ModerationDetail }>;
  ContentCard?: FC<{ report: ModerationDetail; actions: ModerationActions }>;
  /** CONTENT / COMMENT / MESSAGE render Reporter + Reported-User side by side. */
  showReportedUserBesideReporter: boolean;
}

export const VARIANT_REGISTRY: Record<ModerationKind, VariantConfig> = {
  USER: {
    SummaryCard: ReportSummaryCard,
    ContentCard: UserVariantCard,
    showReportedUserBesideReporter: false,
  },
  FEEDBACK: {
    SummaryCard: FeedbackSummaryCard,
    showReportedUserBesideReporter: false,
  },
  CONTENT: {
    SummaryCard: ReportSummaryCard,
    ContentCard: ReportedContentCard,
    showReportedUserBesideReporter: true,
  },
  COMMENT: {
    SummaryCard: ReportSummaryCard,
    ContentCard: ReportedCommentCard,
    showReportedUserBesideReporter: true,
  },
  MESSAGE: {
    SummaryCard: ReportSummaryCard,
    ContentCard: ReportedMessageCard,
    showReportedUserBesideReporter: true,
  },
};
